import { createSelector } from 'reselect';

const getKiosks = (state) => state.businessApp.kiosks;
const getRestaurants = (state) => state.businessApp.restaurants;

export const getKiosksData = createSelector(
    [getKiosks, getRestaurants],
    (kiosks, restaurants) => {
        return kiosks.map(kiosk => {
            const rest = restaurants.find(rest => rest.id === kiosk.restaurantId);
            const restaurantName = rest ? rest.name : '';
            
            return { ...kiosk, restaurantName };
        });
    }
);